import TermsOfUse from "@/pages/termOfUse";
import { createPublicSsrPage } from "../../src/vike/createPublicSsrPage";
import { PATHS } from "../../src/shared/publicPaths";

export default createPublicSsrPage({
  pathname: PATHS.terms,
  overrideKey: "termOfUse",
  element: <TermsOfUse />,
});
